import { render } from "./ChildAccount.vue?vue&type=template&id=843d5b4e&ts=true"
import script from "./ChildAccount.vue?vue&type=script&lang=ts"
export * from "./ChildAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__